import React from "react";
import { Dropdown, Button } from "antd";
import { LogoutOutlined, DownOutlined, MenuOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import EnvironmentSelector from "./EnvironmentSelector";

export default function AppHeader({ showMenuButton = false, onMenuClick }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const userMenuItems = [
    {
      key: "email",
      label: (
        <span className="text-[12px] text-slate-500">{user?.email}</span>
      ),
      disabled: true,
    },
    { type: "divider" },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Sign out",
      onClick: handleLogout,
      danger: true,
    },
  ];

  const initials = user?.name
    ? user.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2)
    : "U";

  return (
    <header className="app-header">
      <div className="app-header-left">
        {showMenuButton && (
          <Button
            type="text"
            icon={<MenuOutlined className="text-[18px]" />}
            onClick={onMenuClick}
            aria-label="Open menu"
            className="app-header-menu-btn"
          />
        )}
      </div>
      <div className="app-header-right">
        <EnvironmentSelector />
        <div className="header-divider" />
        <Dropdown
          menu={{ items: userMenuItems }}
          placement="bottomRight"
          trigger={["click"]}
        >
          <div className="header-user">
            <div className="header-user-avatar">
              {user?.picture ? (
                <img src={user.picture} alt={user.name} />
              ) : (
                initials
              )}
            </div>
            <span className="header-user-name">{user?.name}</span>
            <DownOutlined className="text-[10px] text-slate-400" />
          </div>
        </Dropdown>
      </div>
    </header>
  );
}
